import { Instagram } from "lucide-react";

export const SiteFooter = () => (
  <footer className="bg-[hsl(var(--ink))] text-[hsl(var(--linen))] mt-32">
    <div className="container-editorial py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5">
          <div className="font-serif-logo text-3xl tracking-[0.4em]">ATA</div>
          <p className="mt-4 text-sm text-white/70 max-w-sm">
            A boutique island home in Rarotonga, Cook Islands. Hosted with care by AJ &amp; Brad.
          </p>
        </div>
        <div className="md:col-span-4 text-sm space-y-2 text-white/80">
          <div className="tracking-eyebrow text-[10px] text-white/50 mb-3">Contact</div>
          <a href="mailto:bookings@atahouserarotonga.com" className="block hover:text-white">
            bookings@atahouserarotonga.com
          </a>
          <div>Rarotonga, Cook Islands</div>
        </div>
        <div className="md:col-span-3 text-sm space-y-3">
          <div className="tracking-eyebrow text-[10px] text-white/50 mb-3">Follow</div>
          <a
            href="https://www.instagram.com/atahouserarotonga/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-opacity"
          >
            <Instagram size={16} strokeWidth={1.5} /> @atahouserarotonga
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/15 text-xs text-white/55 flex flex-col md:flex-row justify-between gap-4">
        <div>© {new Date().getFullYear()} Ata House · Rarotonga, Cook Islands</div>
        <div className="max-w-md md:text-right italic font-light">
          Small boutique stays like ours grow through word of mouth — if you&apos;ve stayed with us,
          we&apos;d love a review or recommendation.
        </div>
      </div>
    </div>
  </footer>
);
